import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionData } from '../../domain/session-data';
import { takeUntil, switchMap } from 'rxjs/operators';
import { SessionDataService } from '../../services/session-data/session-data.service';
import { Subject } from 'rxjs';
import { AmountPipe } from '../../pipes/amount.pipe';
import { UserData } from '../../domain/user-data';
import { UserDataService } from '../../services/user-data/user-data.service';
import { DecryptUrlAppService } from '../../services/decrypt-url-app/decrypt-url-app.service';

@Component({
  selector: 'app-login-app',
  templateUrl: './login-app.component.html',
  styleUrls: ['./login-app.component.scss']
})
export class LoginAppComponent implements OnInit {
  isInitialLoading: boolean;
  sessionData: SessionData;
  rejectLink: string;
  userData: UserData;

  @Output() initialDataLoaded: EventEmitter<any> = new EventEmitter();

  private unsubscribe: Subject<void> = new Subject();

  constructor(private route: ActivatedRoute,
    private sessionService: SessionDataService,
    private userDataService: UserDataService,
    private decryptUrlAppService: DecryptUrlAppService,
    private router: Router) { }

  ngOnInit() {
    this.cleanSessionValues();
    this.isInitialLoading = true;
    const id = this.route.snapshot.paramMap.get('id');
    this.sessionData = new SessionData();
    this.sessionData.entryParam = id;
    this.sessionData.isApp = true;

    this.sessionService.setSessionData(this.sessionData)
    .pipe(takeUntil(this.unsubscribe), switchMap((_) => this.decryptUrlAppService.decryptAppUrl(id)))
    .subscribe(
      (response: any) => {
        if (response.statusCode === 'SUCCESS') {
          this.processAgreementData(response);
          this.processLoginData(response);

          this.processUserData(response);
          this.userDataService.setUserData(this.userData).pipe(takeUntil(this.unsubscribe)).subscribe(
            (_) => this.router.navigate(['confirmation'], { relativeTo: this.route.pathFromRoot[0] })
          );

        } else {
          this.sessionData.providerLink = response.redirectUrl;
          this.sessionData.entityName = response.tppName;
          this.sessionService.setSessionData(this.sessionData).pipe(takeUntil(this.unsubscribe)).subscribe(
            (_) => this.router.navigate(['error'], { relativeTo: this.route.pathFromRoot[0] })
          );
        }
        this.isInitialLoading = false;
        this.initialDataLoaded.emit(null);
      }, (error: any) => {
        if (error.status === 400 && this.sessionData.isApp) {
          this.sessionData.requestExpired = true;
          this.sessionData.providerLink = error.error.redirectUrl;
          this.sessionData.entityName = error.error.tppName;
          this.sessionService.setSessionData(this.sessionData).pipe(takeUntil(this.unsubscribe)).subscribe(
            (_) => this.router.navigate(['error'], { relativeTo: this.route.pathFromRoot[0] })
          );
        } else {
        this.router.navigate(['error'], { relativeTo: this.route.pathFromRoot[0] });
      }
      }
    );
  }


  processAgreementData(output: any) {

    if (output.agreementInfo.agreementType === 'A') {
      this.sessionData.agreementId = output.agreementInfo.A1;
      this.sessionData.entityName = output.agreementInfo.A2;
      this.sessionData.providerLink = output.agreementInfo.A4;
      this.sessionData.agreementMap = output.agreementInfo.UI;
      this.sessionData.agreementType = output.agreementInfo.agreementType;

    } else if (output.agreementInfo.agreementType === 'P') {
      this.sessionData.agreementId = output.agreementInfo.P1;
      this.sessionData.paymentType = output.agreementInfo.P3;
      this.sessionData.entityName = output.agreementInfo.P4;
      this.sessionData.paymentAmount = output.agreementInfo.P5;
      this.sessionData.paymentAmount = new AmountPipe().transform(this.sessionData.paymentAmount);
      this.sessionData.paymentCurrency = output.agreementInfo.P6;
      this.sessionData.paymentBenef = output.agreementInfo.P7;
      this.sessionData.isToSelectPaymentAccount = output.agreementInfo.P8;
      this.sessionData.providerLink = output.agreementInfo.P10;
      this.sessionData.agreementMap = output.agreementInfo.UI;
      this.sessionData.agreementType = output.agreementInfo.agreementType;

    } else {
      this.router.navigate(['error'], { relativeTo: this.route.pathFromRoot[0] });
    }
  }

  processLoginData(response: any) {
    this.sessionData.isLoginOk = true;

    if (response.userData.channel === 'P') {
      this.sessionData.safActivated = response.userData.SafActivated;

      this.userData = new UserData();
      this.userData.username = response.userData.username;
      this.userData.channel = response.userData.channel;
      this.userData.mobilePhone = response.userData.mobilePhone;
      this.userData.canSignOperations = 'true';
    } else if (response.userData.channel === 'E') {

      this.userData = new UserData();
      this.userData.username = response.userData.username;
    }

    this.sessionData.channel = response.userData.channel;

    this.sessionService.setSessionData(this.sessionData).pipe(takeUntil(this.unsubscribe)).subscribe();

    this.userDataService.setUserData(this.userData).pipe(takeUntil(this.unsubscribe)).subscribe();
  }

  processUserData(response: any) {

    if (response.userData.channel === 'E') {
      this.userData.mobilePhone = response.userData.mobilePhone;
      this.userData.companyId = response.userData.companyId;
    }
  }


  cleanSessionValues() {
    sessionStorage.removeItem('sessionData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('paymentAgreementData');
    sessionStorage.removeItem('accountAgreementData');
  }
}
